/**
 * Confirms an upload and warns when the image may not render well in Showroom, or says nothing when it will.
 * @module
 */
import { NOTIFICATION_TIMEOUTS } from "common/constants";
import type { UserNotificationType } from "common/types/userNotification";
import { validateSalesImageDimensions } from "lib/options/salesImageValidation";

type SetUserNotification = (notification: UserNotificationType | null) => void;

export function notifySalesImageWarning(
  dimensions: { width?: number; height?: number },
  setUserNotification: SetUserNotification,
): void {
  const { width, height } = dimensions;
  if (!width || !height) {
    return;
  }

  const warning = validateSalesImageDimensions({ width, height });
  if (!warning) {
    return;
  }

  setUserNotification({
    messageType: "warning",
    message: `Image uploaded. ${warning}`,
    timeout: NOTIFICATION_TIMEOUTS.LONG,
  });
}
